import { ClearRounded } from "@mui/icons-material";
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const Payments = ({ values, setValues, settings }) => {
  const { t } = useTranslation();
  const handleDelete = (key) => {
    setValues((val) => ({
      ...val,
      payments: [...val.payments.filter((x) => x.key !== key)],
    }));
  };

  return (
    <>
      <TableContainer
        className="bg-white br-12"
        sx={{
          border: "1px solid var(--primarySM-color)",
          boxShadow: "var(--shadow-xs)",
        }}
      >
        <Table sx={{ minWidth: 300 }} size="small">
          <TableBody>
            {values.payments &&
              values.payments.map((payment, i) => (
                <TableRow key={i}>
                  <TableCell>
                    <div className="d-flex g-20 a-center">
                      <IconButton
                        onClick={() => handleDelete(payment.key)}
                        size="small"
                        sx={{ p: "2px" }}
                      >
                        <ClearRounded className="fs-16" color="error" />
                      </IconButton>
                      <span className="fs-15 gray-color">
                        {payment.methodTitle}
                      </span>
                    </div>
                  </TableCell>

                  <TableCell align="right">
                    <span className="fs-15 gray-color">
                      {settings.curSymbol} {payment.amount}
                    </span>
                  </TableCell>
                </TableRow>
              ))}
            <TableRow>
              <TableCell
                className="fw-6 gray-color tx-upp"
                sx={{ borderBottom: "none" }}
              >
                {t("totalReceived")}
              </TableCell>
              <TableCell
                align="right"
                className="fs-16 fw-6 gray-color"
                sx={{ borderBottom: "none" }}
              >
                {settings.curSymbol}{" "}
                {(values.received || 0).toFixed(settings.decimal)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default Payments;
